import { combineReducers } from "redux"
import authReducer from './auth'
import othersReducer from "./others"
import scheduleReducer from "./schedule"
import autorizacionReducer from "./autorizacion"
 
const mainReducer = combineReducers({
   auth: authReducer,
   schedule: scheduleReducer,
   others: othersReducer,
   autorizacion: autorizacionReducer
})
 
export default mainReducer